import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  title: {
    fontSize: "24px",
    fontWeight: 600,
    marginBottom: "5px",
  },
  filterButtons: {
    height: "7%",
    backgroundColor: "#1B1D28",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "10px",
    padding: "0px",
    gap: "4px",
    flexWrap: "no-wrap",
    [theme.breakpoints.up("xl")]: {
      padding: "0px 10px 10px 10px",
    },
  },

  button: {
    fontSize: "14px",
    borderRadius: "5px",
    color: theme.palette.text.tertiary,
    padding: "0px",
    [theme.breakpoints.up("xl")]: {
      padding: "0px 4px",
    },
  },
  selectedButton: {
    backgroundColor: theme.palette.secondary.main,
    fontSize: "14px",
    borderRadius: "5px",
  },
  icon: {
    marginRight: "5px",
  },
  cardContentDiv2: {
    // width: "100%",
    // height: "4rem",
    display: "grid",
    placeItems: "center",
    // border: `2px solid ${theme.palette.text.primary}`,
    borderRadius: "5px",
    backgroundColor: "#252A38",
    padding: "4px 10px 4px 10px",
    fontSize: "12px",
  },

  //common styles
  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default useStyles;
